import { palette, layouts, animations, typography } from '../theme';

// Common component styles based on theme
export const componentStyles = {
  // Graph header styling
  graphHeader: {
    fontFamily: typography.fontFamily,
    fontStyle: 'normal',
    fontWeight: typography.h5.fontWeight,
    fontSize: typography.h5.fontSize,
    lineHeight: typography.h5.lineHeight,
    color: palette.text.primary,
  },

  // Chart wrapper styling
  chartWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '180px',
    marginTop: '12px',
  },

  // Card wrapper with border
  cardWrapperWithBorder: {
    ...layouts.cardWrapper,
    border: `1px solid ${palette.grey[200]}`,
    borderRadius: '8px',
    background: palette.background.paper,
  },

  // Tooltip styles
  customTooltip: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: palette.background.paper,
      color: palette.text.primary,
      fontSize: '12px',
      border: `1px solid ${palette.grey[200]}`,
      boxShadow: '0 0 2px rgba(0,0,0,0.5)',
    },
    '& .MuiTooltip-arrow': {
      color: palette.background.paper,
      boxShadow: '0 0 2px rgba(0,0,0,0.5)',
      fontSize: 2,
    },
  },

  // Bottom border divider
  bottomBorder: {
    width: '90%',
    borderBottom: `1px solid ${palette.grey[300]}`,
    margin: '15px auto',
  },

  // Flexbox utilities
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  // Responsive gap utilities
  gapSmall: { gap: '8px' },
  gapMedium: { gap: '16px' },
  gapLarge: { gap: '24px' },

  // Background image card
  backgroundImageCard: (imageUrl: string) => ({
    ...layouts.cardWrapper,
    backgroundImage: `url(${imageUrl})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }),
};

// Helper function to create responsive styles
export const createResponsiveStyle = (baseStyle: any, mobileOverrides: any = {}) => ({
  ...baseStyle,
  '@media (max-width: 768px)': {
    ...mobileOverrides,
  },
});

// Helper function to create animation styles
export const withAnimation = (
  baseStyle: any,
  animationType: keyof typeof animations = 'appearanceEffect'
) => ({
  ...baseStyle,
  ...animations[animationType],
});

// Helper function to create hover styles
export const withHover = (baseStyle: any, hoverStyle: any) => ({
  ...baseStyle,
  '&:hover': hoverStyle,
});

// Color utility functions
export const getColorFromPalette = (colorPath: string) => {
  const pathArray = colorPath.split('.');
  let result: any = palette;

  for (const key of pathArray) {
    if (result && typeof result === 'object' && key in result) {
      result = result[key];
    } else {
      return undefined;
    }
  }

  return typeof result === 'string' ? result : undefined;
};

// Spacing utility
export const getSpacing = (multiplier: number) => `${8 * multiplier}px`;
